export const FLEX_SCROLL_CLASS = 'flexScroll';
